var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./Button.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2b2e6818\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Button.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Button/Button.vue.html
// module id = Oa7e
// module chunks = 2